import { Box, Typography } from '@mui/material';

import { useAppSelector } from 'state/hooks';
import { selectTargetDate, selectTargetEndDate } from 'state/workflowSlice';

import { formatDateOrDateRange } from 'features/common/datetimeUtils';
import { useRouteProperties } from 'features/common/hooks/useRouteProperties';
import { MaximizeButton } from 'features/workspace/MaximizeButton';

import styles from 'features/workspace/Workspace.module.css';

export function ChartHeaderTitle({
  title,
  subtitle,
  date,
}: {
  title: string;
  subtitle: string;
  date: string;
}) {
  const hasAllData = title && subtitle && date;
  return (
    <Box className={styles.chart_header_inner}>
      <Typography className={styles.chart_header_title} variant="h4">
        {title}
      </Typography>
      {hasAllData && <Typography variant="body2">|</Typography>}
      <Typography variant="body2">{subtitle}</Typography>
      {hasAllData && (
        <Box className={styles.chart_header_date}>
          <Typography variant="caption">{date}</Typography>
        </Box>
      )}
    </Box>
  );
}

function SegmentInfoChart({ graph_title }: { graph_title: string }) {
  const targetDate = useAppSelector(selectTargetDate);
  const targetEndDate = useAppSelector(selectTargetEndDate);
  const routeProperties = useRouteProperties();

  if (!routeProperties || !targetDate) return null;

  const { name, cardinalDirection } = routeProperties;
  const subtitle = `${name} ${cardinalDirection}`;

  return (
    <ChartHeaderTitle
      title={graph_title}
      subtitle={subtitle}
      date={formatDateOrDateRange(targetDate, targetEndDate, 'D MMM, YYYY')}
    />
  );
}

export function ChartHeader({ graph_title }: { graph_title: string }) {
  return (
    <div className={styles.chart_header}>
      <div className={styles.chart_header_left}>
        <SegmentInfoChart graph_title={graph_title} />
      </div>

      <div className={styles.chart_header_right}>
        <MaximizeButton />
      </div>
    </div>
  );
}
